import { Text } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Pressable, ScrollView } from 'native-base';
import React from 'react';

export interface SelectableTagOption {
  label: string;
  value: string;
}

export interface SelectableTagsProps {
  options: SelectableTagOption[];
  selectedValues: string[];
  onChange: (value: string, selected: boolean) => void;
  testIDPrefix?: string;
}

const tagInk = 'brand.primary.principal' as const;

export const SelectableTags: React.FC<SelectableTagsProps> = ({
  options,
  selectedValues,
  onChange,
  testIDPrefix = 'selectable-tag',
}) => {
  if (!options.length) {
    return null;
  }

  return (
    <ScrollView horizontal showsHorizontalScrollIndicator={false} width="full">
      <Box flexDirection="row" alignItems="center">
        {options.map((option, index) => {
          const isSelected = selectedValues.includes(option.value);
          const borderColor = Utils.ColorToken.WithOpacity(
            tagInk,
            isSelected ? 'opacity.semiopaque' : 'opacity.medium'
          );
          const color = borderColor;
          const bg = isSelected
            ? Utils.ColorToken.WithOpacity(tagInk, 'opacity.semitransparent')
            : Color['neutral.white'];

          return (
            <Pressable
              key={option.value}
              testID={`${testIDPrefix}-${option.value}`}
              onPress={() => onChange(option.value, !isSelected)}
              mr={index === options.length - 1 ? 0 : Spacing['inline.nano']}
              px={Spacing['inline.xxxs']}
              py={Spacing['inset.quarck']}
              borderRadius="full"
              borderWidth={1}
              borderColor={borderColor}
              bg={bg}>
              <Text
                variant="semibold"
                fontSize={Typography['fontsize.sm']}
                color={color}
                selectable={false}>
                {option.label}
              </Text>
            </Pressable>
          );
        })}
      </Box>
    </ScrollView>
  );
};
